<template>
  <div class="px-2 text-gray pb-4">
    <!-- <div class="pb-4 text-xs text-black">Bookmarks</div> -->
    <div v-for="(u, i) in urls" class="border border-gray mb-4 rounded">
      <div class="font-normal tracking-wide flex bg-gray-lightest">
        <div class="url__img border- border-gray" :style="'background-image: url(' + u.image + ');'"></div>


        <div class="p-4 flex-1 bg-white">
          <!-- <div class="pb-2 leading-normal text-xs">
            <a class="text-gray no-underline" :href="u.href">{{u.href}}</a>
                 </div> -->
          <div class="font-bold pb-2 leading-normal text-sm url__title">
            <a class="text-gray" :href="u.href">{{u.title}}</a>
          </div>

          <div class="text-xs leading-normal">
            <p>{{u.description}}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
 export default {
   props: {
     urls: {
       type: Array,
       required: true
     }
   }
 }
</script>


<style scoped>
 .url__img {
   width: 130px;
   height: 130px;
   background-size: cover;
   background-position: center top;
   background-repeat: no-repeat;
 }

 .url__title {
   word-break: break-all;
   word-break: break-word;
   overflow-wrap: anywhere;
 }



</style>
